<template>
    <div :class="'navigation-view-' + type" class="navigation-view-wrapper">
        <div class="navigation-view-title" v-if="views.length && type !== 'history' && type !== 'min'">{{title}}</div>
        <div v-for="(view, index) in views" :key="index">
            <div v-if="type === 'max'" class="navigation-view-item">
                <component :is="view.cType" v-bind="view"></component>
            </div>
            <div v-else-if="view.title || view.cId || view.windowName" class="navigation-view-item">
                <div class="navigation-view-item-header">{{ view.title || view.cId || view.windowName }}</div>
                <navigation-buttons :view="view" :used-from="type"></navigation-buttons>
            </div>
        </div>
        <div v-if="!views.length">
            No items in {{title}}
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "vue";

let navigationViewsCmp = {
    name: 'navigationViews',
    props: {
        type: {
            default: false
        }
    },
    data() {
        return {};
    },
    mounted() {
        if (this.type) {
            this.navigationStore?.allowedButtons?.push?.(this.type);
        }
    },
    computed: {
        navigationStore() {
            return typeof navigationStore === 'function' ? navigationStore() : {};
        },
        title() {
            let title = '';
            switch (this.type) {
                case 'min':
                    title = 'Minimized';
                    break;
                case 'max':
                    // title = 'Maximize';
                    break;
                case 'history':
                    title = 'History';
                    break;
            }
            return title;
        },
        views() {
            let views = [];
            if (this.type === 'history') {
                views = this.navigationStore?.history || [];
            } else if (this.type === 'min' || this.type === 'max') {
                let tmpViews = this.navigationStore?.views;
                for (let i in tmpViews) {
                    if (tmpViews[i].openedIn === this.type) {
                        views.push(tmpViews[i].config);
                    }
                }
            }
            return views;
        },
    },
    methods: {},
    components: {
        'navigation-buttons': defineAsyncComponent(() => import('@common/navigation/navigationButtons')),
    },
};

export { navigationViewsCmp };
export default navigationViewsCmp;
</script>

<style scoped>
.navigation-view-item {
    flex-direction: row;
    display: flex;
    border: 1px solid lightgrey;
    padding: 5px;
    border-radius: 5px;
    margin-bottom: 5px;
}
.navigation-view-item-header {
    line-height: 28px;
    flex-grow: 12;
    text-align: left;
}

.navigation-view-history {
    max-height: 200px;
    overflow: scroll;
}

.navigation-view-wrapper {
    padding: 10px;
}
</style>
